/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Wsdp_ReadyInputs */

const cs_property_registry_wsdp_ready = /** @type {(inputs: Property_Registry_Wsdp_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výpis LV je k dispozici`)
};

const en_property_registry_wsdp_ready = /** @type {(inputs: Property_Registry_Wsdp_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title-deed extract is available`)
};

/**
* | output |
* | --- |
* | "Title-deed extract is available" |
*
* @param {Property_Registry_Wsdp_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_wsdp_ready = /** @type {((inputs?: Property_Registry_Wsdp_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Wsdp_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_wsdp_ready(inputs)
	return cs_property_registry_wsdp_ready(inputs)
});